"use client";

import { useTranslations } from "next-intl";
import CardAvatar from "@/components/cardElements/CardAvatar";
import { Card, CardContent } from "@/components/ui/card";
import { GenderIcon } from "../GenderIcon";
import { Gender } from "@/components/modules/listings/api/schema";
type DemandUser = {
  image?: string | null;
  name?: string | null;
  bio?: string | null;
};

/**
 * Demand's replacement for the images card: the seeker's avatar next to a gray
 * box with their name (as "{name}'s biography") and bio.
 */
export function DemandUserCard({
  user,
  gender,
  hideAvatar
}: {
  user?: DemandUser;
  gender?: Gender;
  hideAvatar?: boolean;
}) {
  const t = useTranslations("modules.realEstateDetail");
  const bio = <div className="flex w-full flex-1 flex-col justify-start gap-1 self-stretch rounded-lg bg-muted p-4">
      <div className="flex items-center gap-2">
        <h3 className="text-base font-semibold text-foreground-heading">
          {user?.name ? t("biographyOf", {
          name: user.name
        }) : t("biography")}
        </h3>
        {gender && <GenderIcon gender={gender} />}
      </div>
      {user?.bio && <p className="text-foreground-secondary whitespace-pre-line">{user.bio}</p>}
    </div>;

  // Mobile (avatar already shown as the hero): just the gray bio box, no card.
  if (hideAvatar) return bio;
  return <Card className="bg-card border-none shadow-sm" data-sentry-element="Card" data-sentry-component="DemandUserCard" data-sentry-source-file="DemandUserCard.tsx">
      <CardContent className="py-8" data-sentry-element="CardContent" data-sentry-source-file="DemandUserCard.tsx">
        <div className="flex flex-col sm:flex-row items-center gap-5 w-full">
          <CardAvatar imgUrl={user?.image || ""} name={user?.name ?? undefined} className="w-32 h-32 sm:w-82 sm:h-82 border-2 border-card shadow-md shrink-0" data-sentry-element="CardAvatar" data-sentry-source-file="DemandUserCard.tsx" />
          {bio}
        </div>
      </CardContent>
    </Card>;
}